// @flow

import * as React from "react";
import cx from "classnames";
import { useHistory } from "react-router-dom";
import { currentYear } from "../../utils/date";
import getFooterLinks from "../../data/footerLinks";

import styles from "./Footer.scss";

type FooterProps = {
  type: "portal" | "inquiry",
  customBasename: string
};

const Footer = ({ type, customBasename }: FooterProps) => {
  const history = useHistory();
  const basename = customBasename || history.createHref({ pathname: "/" });
  const links = getFooterLinks(basename);

  return (
    <div className={styles.container}>
      <div
        className={cx(styles.content, {
          [styles.contentPortal]: type === "portal",
          [styles.contentInquiry]: type === "inquiry"
        })}
      >
        <span className={styles.copy}>
          {`${currentYear} - Ein Serviceangebot der Deutschen Bürgschaftsbanken.`}
        </span>
        <span>
          {links.map(({ href, title }, index) => (
            <React.Fragment key={title}>
              <a
                className={styles.linkTo}
                href={href}
                aria-label={title}
                target="_blank"
                rel="noreferrer"
              >
                {title}
              </a>
              {index !== links.length - 1 && <span className={styles.separator}> – </span>}
            </React.Fragment>
          ))}
        </span>
      </div>
    </div>
  );
};

export default Footer;
